import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { loadSingleCompany } from "../../../Company/CompanyList/CompanyList.actionCreators";

const CompanyMenu = (props) => {
  const { t, handleNavItemClick, handleContextMenu } = props;
  const params = useParams();
  const companyId = parseInt(params.id, 10);
  const dispatch = useDispatch();

  const [companyData, setCompanyData] = useState([]);
  const companyInfo = useSelector(
    (state) => state.companyList.byId[parseInt(params.id)]
  );

  const selectedCompanyData = useSelector(
    (state) => state.companyList.selectedCompany
  );

  const fetchCompanyInfo = () => {
    dispatch(
      loadSingleCompany({
        companyId,
      })
    );
  };

  useEffect(() => {
    if (companyInfo === undefined) {
      fetchCompanyInfo();
    }
  }, [companyInfo, params.id]);

  useEffect(() => {
    if (
      companyInfo !== undefined &&
      parseInt(companyId, 10) === parseInt(companyInfo.id, 10)
    ) {
      setCompanyData(companyInfo);
    }
    if (
      selectedCompanyData !== null &&
      parseInt(companyId, 10) === parseInt(selectedCompanyData.id, 10)
    ) {
      setCompanyData(selectedCompanyData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyInfo, selectedCompanyData]);

  return (
    <div className="sub-list">
      <ul>
        <li
          data-link={`/company/view/${params.id}/general-info`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "general-info" ? "active" : ""}
        >
          {t("MENU_COMPANIES_GENERAL_INFORMATION")}
        </li>
        {/* <li
          data-link={`/company/view/${params.id}/financial-info`}
          onClick={handleNavItemClick}
          className={params.path === "financial-info" ? "active" : ""}
        >
          {t("MENU_COMPANIES_FINANCIAL_INFORMATION")}
        </li> */}
        <li
          data-link={`/company/view/${params.id}/contacts`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "contacts" ? "active" : ""}
        >
          {t("MENU_COMPANIES_CONTACTS")}
        </li>
        <li
          data-link={`/company/view/${params.id}/meeting-reports`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "meeting-reports" ? "active" : ""}
        >
          {t("MENU_COMPANIES_MEETING_REPORTS")}
        </li>
        <li
          data-link={`/company/view/${params.id}/documents`}
          onClick={handleNavItemClick}
          onContextMenu={handleContextMenu}
          className={params.path === "documents" ? "active" : ""}
        >
          {t("MENU_COMPANIES_DOCUMENTS")}
        </li>
        {companyData.isClient && (
          <li
            data-link={`/company/view/${params.id}/sites`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "sites" ? "active" : ""}
          >
            {t("MENU_COMPANIES_SITES")}
          </li>
        )}
        {companyData.isSupplier && (
          <li
            data-link={`/company/view/${params.id}/centres`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "centres" ? "active" : ""}
          >
            {t("MENU_COMPANIES_CENTRES")}
          </li>
        )}
        {companyData.isCentre && (
          <li
            data-link={`/company/view/${params.id}/products`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={
              params.path === "products" ||
              params.hasOwnProperty("productId") ||
              params.path === "create"
                ? "active"
                : ""
            }
          >
            {t("MENU_COMPANIES_PRODUCTS")}
          </li>
        )}

        {companyData.isCentre && (
          <li
            data-link={`/company/view/${params.id}/history`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "history" ? "active" : ""}
          >
            {t("COMPANY_HISTORY_SOLUTIONS")}
          </li>
        )}

        {companyData.isHaulier && (
          <li
            data-link={`/company/view/${params.id}/warehouses`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={
              params.path === "warehouses" ||
              params.hasOwnProperty("warehouseId")
                ? "active"
                : ""
            }
          >
            {t("MENU_COMPANIES_WAREHOUSES")}
          </li>
        )}
        {(companyData.isHaulier || companyData.isCentre || companyData.isSupplier)  && (
          <li
            data-link={`/company/view/${params.id}/purchase-orders`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "purchase-orders" ? "active" : ""}
          >
            {t("MENU_COMPANIES_PURCHASE_ORDERS")}
          </li>
        )}
        {(companyData.isClient) && (
          <li
            data-link={`/company/view/${params.id}/invoices`}
            onClick={handleNavItemClick}
            onContextMenu={handleContextMenu}
            className={params.path === "invoices" ? "active" : ""}
          >
            {t("MENU_COMPANIES_INVOICES")}
          </li>
        )}
      </ul>
    </div>
  );
};

CompanyMenu.propTypes = {
  t: PropTypes.func.isRequired,
  handleNavItemClick: PropTypes.func.isRequired,
  handleContextMenu: PropTypes.func.isRequired,
};

export default withTranslation()(CompanyMenu);
